// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ProcessAdvanceDiscountsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/process_advance_discounts
 *
 * Returns two parallel lists: successfully-applied advance discounts
 * (`processed`) and per-advance failures encountered during the foreach
 * (`errors`). The transaction wraps the whole batch — if it rolls back,
 * the controller emits an error envelope instead, so this contract is
 * only reached when the DB commit succeeded.
 *
 * @see Payroll::process_advance_discounts() controller
 * @see Employee_advances_model::processDiscounts()
 */
import type { Payroll_ProcessAdvanceDiscountsErrorRow } from './Payroll_ProcessAdvanceDiscountsErrorRow'
import type { Payroll_ProcessAdvanceDiscountsProcessedRow } from './Payroll_ProcessAdvanceDiscountsProcessedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ProcessAdvanceDiscountsResponseDados {
processed: Payroll_ProcessAdvanceDiscountsProcessedRow[]
errors: Payroll_ProcessAdvanceDiscountsErrorRow[]
}

export type Payroll_ProcessAdvanceDiscountsResponse = ApiResponse<Payroll_ProcessAdvanceDiscountsResponseDados>;

registerResponseContract('Payroll_ProcessAdvanceDiscountsResponse', {
  processed: {
    type: 'array',
    required: true,
    items: {
      advance_id: { type: 'number',  required: true },
      item_id:    { type: 'number',  required: true },
      amount:     { type: 'number',  required: true },
      new_status: { type: 'number',  required: true },
    },
  },
  errors: {
    type: 'array',
    required: true,
    items: {
      advance_id: { type: 'number',  required: true },
      error:      { type: 'string',  required: true },
    },
  },
})
